import React from 'react';
import { useSelector } from 'react-redux';
import SocialShareModalAICaptionsField from 'containers/SocialShareModal/SocialShareModalAICaptionsField';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';
import { useSocialShareModal } from 'containers/SocialShareModal/SocialShareModalContext';
import { threadsIsPostingSelector } from 'redux/modules/social';
import { THREADS_MAX_DESCRIPTION_CHARS } from './constants';

export type ThreadsPostComposerStepProps = {};

const ThreadsPostComposerStep: React.FC<ThreadsPostComposerStepProps> = () => {
  const isPosting = useSelector(threadsIsPostingSelector);

  const { description, setDescription } = useSocialShareModal();

  return (
    <SocialShareModalBody loadingTitle="Posting Video" isLoading={isPosting}>
      <SocialShareModalAICaptionsField
        inputProps={{
          value: description,
          maxChars: THREADS_MAX_DESCRIPTION_CHARS,
          onChange: setDescription,
        }}
      />
    </SocialShareModalBody>
  );
};

export default ThreadsPostComposerStep;
